import { useParams, useSearchParams } from 'react-router-dom';
import DesignEditor from '../DesignEditor';
import { useEffect, useState } from 'react';
import { getCurrentDesign, getFlow } from '../../_rego.service';

const FlowEditor = () => {
    const { flow_id } = useParams();
    const [searchParams] = useSearchParams();
    const [flow, setFlow] = useState({});
    const [design, setDesign] = useState({});

    useEffect(() => {
        initFlow();
        initDesign();
    }, []);

    const initFlow = async () => {
        const response = await getFlow(flow_id);
        setFlow(response);
    };

    const initDesign = async () => {
        const response = await getCurrentDesign(flow_id);
        setDesign(response);
    };

    return (
        <>
            {design.id && flow.id && (
                <DesignEditor
                    flow={flow}
                    details={design}
                />
            )}
        </>
    );
};
export default FlowEditor;
